import LogUtil from '../../../core/utils/LogUtil';

export class PointService {
  constructor(pointRepository) {
    this.pointRepository = pointRepository;
  }

  async getBalance(userId) {
    if (!userId) throw new Error('사용자 ID가 필요합니다.');
    return await this.pointRepository.getBalance(userId);
  }

  async earnPoints(data) {
    if (!data.amount || data.amount < 1) throw new Error('포인트 금액이 필요합니다.');
    LogUtil.log('[PointService] 포인트 지급:', data);
    return await this.pointRepository.earnPoints(data);
  }

  async getTransactions(userId, params = {}) {
    if (!userId) throw new Error('사용자 ID가 필요합니다.');
    return await this.pointRepository.getTransactions(userId, params);
  }

  async getEligibleCount(pharmacyId, params = {}) {
    if (!pharmacyId) throw new Error('약국 사업자등록번호가 필요합니다.');
    return await this.pointRepository.getEligibleCount(pharmacyId, params);
  }

  async getPharmacyTransactions(pharmacyId, params = {}) {
    if (!pharmacyId) throw new Error('약국 사업자등록번호가 필요합니다.');
    return await this.pointRepository.getPharmacyTransactions(pharmacyId, params);
  }

  async getPointKpi(brn, params = {}) {
    if (!brn) throw new Error('약국 사업자등록번호가 필요합니다.');
    return await this.pointRepository.getPointKpi(brn, params);
  }

  async getPointStats(brn, params = {}) {
    if (!brn) throw new Error('약국 사업자등록번호가 필요합니다.');
    return await this.pointRepository.getPointStats(brn, params);
  }
}
